import { Hiver_Base_Url, Base_Url, apiRoutes, Hiver_New_Auth_Base_Url } from "../Constant/ApiRoutes";
import axios from "axios";
import { getState, setState, STORAGE_KEYS } from "../Constant/LocalStorage";
import { HiverKbBifrost } from "../Bifrost";
import { API_METHODS } from "../Constant/Bifrost";
import { buildSettings } from "../Constant/Settings";
import { TENANT_PLATFORM } from "@hiver/bifrost-js/lib";

const isNewAuther = buildSettings.NEW_AUTHER;

const axiosInstanceHGT = axios.create({
  credentials: "include",
  withCredentials: true,
  baseURL: Hiver_Base_Url,
});

const axiosInstanceKB = axios.create({
  credentials: "include",
  withCredentials: true,
  baseURL: Hiver_New_Auth_Base_Url
})

const axiosInstanceLogin = axios.create({
  baseURL: Base_Url,
});

axiosInstanceLogin.interceptors.request.use(
  function (config) {
    const token = getState("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export const getToken = (payload) => {
  let config = {
    params: {
      ...payload,
    },
  };
  return axiosInstanceHGT.get(apiRoutes.hiverGetToken, config);
};

export const completeOAuthHGT = function (authToken, email) {
  const payload = `email=${email}&token=${authToken}`;
  return axiosInstanceHGT.post(apiRoutes.OAuthComplete, payload , {
    headers: {
      "Content-Type": 'application/x-www-form-urlencoded; charset=UTF-8'
    },
  });
};


export const completeOAuthHOT = async function (sso_auth_token, email) {
  const body = {
    sso_auth_token,
    email
  };

  const response = await axiosInstanceKB.post(apiRoutes.kbCompleteOAuth, body );
  const sessionData = response.headers;

  /** storing HOT session data in localStorage. 
   *  this data is passed as headers for profile-me call where access-token is used to validate user session
   *  and bearer token is passed as code for bifrost.
  */
  setState(STORAGE_KEYS.HOT_SESSION_DATA, sessionData );

  return response;
}

const getSessionHeadersHOT = () => {
  const sessionData = getState(STORAGE_KEYS.HOT_SESSION_DATA) ?? {};
  return ( {
      'access-token': sessionData['access-token'],
      'token-type': sessionData['token-type'],
      client: sessionData.client,
      expiry: sessionData.expiry,
      uid: sessionData.uid,
  } )
}

// async key kept to keep function thennable.
export const getHeimdallCodeHOT = async () => { 
    const sessionData =  getState(STORAGE_KEYS.HOT_SESSION_DATA) ?? {};
    return sessionData.authorization;
}

const profileMeHOT = async () =>{ 
    const response = await axiosInstanceKB.get(apiRoutes.kbProfileMe, {
      headers: getSessionHeadersHOT()
    });
    const { data } = response.data;
    const user_id = data.id;
    const usergroup_id = data.accounts[ 0 ].id; // consuming first UG by default assuming most users to have single UG.
    const tenantPlatform = TENANT_PLATFORM.HIVERWEB;
    const getTokenForLogin = getHeimdallCodeHOT;
    return {
      data: {
        user_id, 
        usergroup_id,
        tenantPlatform,
        getTokenForLogin
      }
    }
}

const profileMeHGT = async (config) => {
  try{
    const response = await axiosInstanceHGT.get(apiRoutes.getUserDetails, config);
    return response;
  }
  catch( error ){
      throw new Error("Profile Me Failed", { cause: {
        tenantId: TENANT_PLATFORM.GMAIL,
        error
        }
      }
    );
  }
}

export const getLoggedInUserDetails = (payload = {}) => {
  let config = {
    params: { ...payload },
  };
  return Promise.any([ profileMeHGT(config), profileMeHOT() ]).catch( ( { errors } ) => {
    console.debug(errors);
    const error = errors.find( error => error.cause?.tenantId === TENANT_PLATFORM.GMAIL );
    throw error?.cause?.error;
  });
};

export const newHiverLoginInit = (payload) => {
  return axiosInstanceHGT.post(apiRoutes.newHiverLoginInit, payload, {});
}

export const userAuth = () => {
  if( isNewAuther ){
    return HiverKbBifrost({
      url: apiRoutes.kbAuth,
      method: API_METHODS.GET,
      root_url: Hiver_New_Auth_Base_Url
    });
  } 
  return axiosInstanceLogin.get(apiRoutes.kbAuth);
};

//Get MailBox Contact Details
export const addUserToUserGroup = () => {
  if( isNewAuther ){
    return HiverKbBifrost({
      url: apiRoutes.kbAddUserGroudUser,
      method: API_METHODS.POST,
      root_url: Hiver_New_Auth_Base_Url
    });
  }
  return axiosInstanceLogin.post(apiRoutes.kbAddUserGroudUser);
};

export const loginInitHOT = (provider) => {
  const params = {
    params: {
      provider: provider,
    }
  };
  return  axiosInstanceKB.get(apiRoutes.kbLoginInit, params);
}

export const getEmailProductsHOT = (email) => {
  return axiosInstanceKB.get(apiRoutes.kbVerifyEmailProducts, { params: { email } });
};

export const passwordSignInHOT = async (email, password, otp_attempt = null) => {
  const body = { email, password };
  if (otp_attempt) body.otp_attempt = otp_attempt;
  const response = await axiosInstanceKB.post(apiRoutes.kbAuthSignIn, body);
  const sessionData = response.headers;
  setState(STORAGE_KEYS.HOT_SESSION_DATA, sessionData);
  return response;
};

export const validateTokenHOT = (accessToken) => {
  return axiosInstanceKB.get(apiRoutes.kbValidateToken, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

/** Access-token used for validate_token and session restore. Stored in localStorage under STORAGE_KEYS.HOT_SESSION_DATA. */
export const getStoredAccessTokenHOT = () => {
  const sessionData = getState(STORAGE_KEYS.HOT_SESSION_DATA) ?? {};
  const accessToken = sessionData["access-token"] ?? sessionData["Access-Token"];
  if (accessToken) return accessToken;
  const auth = sessionData.Authorization ?? sessionData.authorization;
  if (auth && /^Bearer\s+/i.test(auth)) return auth.replace(/^Bearer\s+/i, "").trim();
  return null;
};